import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Icon, Dimmer, Loader, Message } from 'semantic-ui-react';

const RemoveWalletItemModal = ({ open, onOpen, onClose, walletItem, onDelete, actions }) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const _onDelete = useCallback(async () => {
		setLoading(true);
		try {
			await actions.removePaymentWalletItem(walletItem.walletId, walletItem.walletItemId, walletItem.fundingAccountToken);
			setLoading(false);
			onDelete();
		} catch(err) {
            setError(err)
			setLoading(false);
		}
	}, [actions, onDelete, walletItem]);

	return (
		<Modal
			size='tiny'
			onOpen={onOpen}
			onClose={onClose}
			open={open}
			trigger={
				<span style={{ marginLeft: '10px', cursor: 'pointer' }}>
					<Icon link name='trash' /> Delete
				</span>
			}>
			<Modal.Header>Are you sure?</Modal.Header>
			<Modal.Content>
				{loading && (
					<Dimmer active inverted>
						<Loader active size='massive'>
							Deleting Wallet Item...
						</Loader>
					</Dimmer>
				)}
				{error && <Message error>Error deleting wallet item: {error.error}</Message>}
				Delete {walletItem.nickname}?
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={onClose}>No</Button>
				<Button primary onClick={_onDelete}>
					Yes
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

RemoveWalletItemModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onOpen: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	actions: PropTypes.object.isRequired,
	walletItem: PropTypes.object.isRequired
};

export default RemoveWalletItemModal;
